export const PROMO_CODE = 'promo_code';
export const GET_ALL_PROMO_CODE = 'get_all_promo_code';

export const GET_ALL_PROMO_CODE_SUCCESS = 'get_all_promo_code_success';
export const DELETE_PROMO_CODE = 'delete_promo_code';

export const GET_PROMO_CODE_MEMBER = 'get_promo_code_member';
export const GET_PROMO_CODE_MEMBER_SUCCESS = 'get_promo_code_member_success';
